import React from 'react';
import './InfoCard.less';
import {SVGIcon} from '@homeaway/react-svg';
import lightbulbIcon from '../../images/lightbulb-icon';

const InfoCard = ({ children, className = '' }) => {
    return (
        <div className={`card info-card ${className}`}>
            <div className="info-card-content-col">
                <div className="lightbulb-icon-holder">
                    <SVGIcon className="lightbulb-icon" markup={lightbulbIcon} />
                </div>
                {children}
            </div>
        </div>
    );
};

export default InfoCard;
